import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-middle overflow-hidden"
};
import { useScreenAuto } from "@/hooks/useScreenAuto/index.js";

import { inject } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const {
      appRef
    } = useScreenAuto();
    const {
      title,
      onCoyp
    } = inject("app-store");
    return (_ctx, _cache) => {
      const _component_AppHeader = _resolveComponent("AppHeader");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        class: "app",
        ref_key: "appRef",
        ref: appRef
      }, [_createVNode(_component_AppHeader, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(title)), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view)]), _createElementVNode("div", {
        class: "copy",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(onCoyp) && _unref(onCoyp)(...args))
      }, " 赣ICP备2025063872号-1 ")], 512);
    };
  }
};